import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsModule } from '@signature-it/ngx-generic/components/cms';
import { NewsletterModuleGeneric } from '@signature-it/ngx-generic/components/newsletter';
import { MainFooterComponent } from './main-footer';

@NgModule({
    imports: [
        CommonModule,
        CmsModule,
        NewsletterModuleGeneric
    ],
    exports: [MainFooterComponent],
    declarations: [MainFooterComponent]
})
export class MainFooterModuleGeneric {}
